module.exports = __webpack_public_path__ + "static/media/github.d2587cdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Footer/github.svg
// module id = 255
// module chunks = 0